module.exports = __webpack_public_path__ + "img/完成.453a9653.png";